/**
 * Route of the full-screen presentation player (the shared-link entry point). Every link, router
 * registration and share URL is built from these, so the path lives in exactly one place.
 */

/** Name of the route parameter carrying the presentation id. */
export const WALLBOARD_PRESENTATION_ROUTE_PARAM = 'presentationId';

/** Router path of the presentation player (no leading slash, as `Routes` expects). */
export const WALLBOARD_PRESENTATION_ROUTE_PATH = `dashboard/wallboard/present/:${WALLBOARD_PRESENTATION_ROUTE_PARAM}`;
